import api from "./api";

export const MapeamentosErrosTwillioService = {
  index: () => {
    return api.get('mapeamento-erros-twillio')
  }
};